import { isMedgateConnect } from "@/modules/patients/agenda/teleconsultation/booking/constants/medgate-connect"
import {
  ADDRESS_SOURCES,
  AddressSource,
  isPartnerAddressSource,
} from "@/modules/patients/agenda/teleconsultation/booking/teleconsultation-schema"
import { Access } from "@/modules/patients/services/__generated__/useCreateAppointmentMutation.graphql"
import { CommunicationChannel, ContactChannel, MedgateConnectChannel, Service } from "@/types/__generated__/union-types"

export const getPhoneNumber = (
  formData: {
    channel: CommunicationChannel
    patientPhoneNumber: string | null
  },
  patientPhoneNumber: string | null,
) => {
  let phoneNumber: string | null = null

  if (formData.channel === "PHONE" || formData.channel === "VIDEO") {
    if (formData.patientPhoneNumber !== patientPhoneNumber) {
      phoneNumber = formData.patientPhoneNumber
    }
  }

  return { phoneNumber }
}

export const resolveAddressSource = (
  medgateConnectChannel?: MedgateConnectChannel | null,
  patientPhoneNumber?: string | null,
  hasPatientAddress?: boolean,
): AddressSource => {
  if (medgateConnectChannel === "PARTNER") {
    return patientPhoneNumber ? ADDRESS_SOURCES.PARTNER_LOCATION : ADDRESS_SOURCES.PARTNER
  }
  if (hasPatientAddress) return ADDRESS_SOURCES.MANUAL
  return ADDRESS_SOURCES.HOME
}

export const resolveMedgateConnectChannel = (
  service: Service,
  addressSource?: AddressSource,
): MedgateConnectChannel | null => {
  if (!isMedgateConnect(service)) return null
  if (isPartnerAddressSource(addressSource)) return "PARTNER"
  return "PATIENT"
}

export const getAccess = (isInContextOfAppointment: boolean, callId?: string | null): Access => {
  if (callId) {
    return "INBOUND_CALL"
  } else if (isInContextOfAppointment) {
    return "OUTBOUND_CALL"
  } else {
    return "WEBSITE"
  }
}

export const isMedicalService = (service: Service) => service !== "ADMINISTRATIVE_REQUEST"

export const isChatSelectable = ({
  contactChannel,
  service,
  isMedicalChatEnabled,
}: {
  contactChannel: ContactChannel
  service: Service
  isMedicalChatEnabled: boolean
}) => contactChannel === "APP" && (isMedicalChatEnabled || !isMedicalService(service))
